import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Play = ({
  className,
  color = '#fff',
  width = 32,
  height = 32,
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      aria-hidden="true"
    >
      <path d="M9 27.333V4L27.334 15.667L9 27.333Z" fill={color} />
    </svg>
  );
};
